import { http } from '@/api/http'
import type { ContentLocale } from '@/types/api'

/** One notification of the signed-in profile (GET /notifications), localized by the server. */
export type InboxNotification = {
  guid: string
  title: string
  message: string
  image: string
  type: string[]
  /** An app path; admin pages such as /sales/work-tasks?sheet=<id> open from the bell. */
  screen: string
  is_read: boolean
  read_at: string
  created_at: string
}

export type InboxPage = {
  notifications: InboxNotification[]
  has_more: boolean
}

/** The caller's own inbox; the server restricts every call to the authenticated profile. */
export const notificationsService = {
  async list(params: { lang: ContentLocale; limit: number; offset: number }, signal?: AbortSignal) {
    const { data } = await http.get<InboxPage>('/notifications', { params, signal })
    return { notifications: data.notifications ?? [], has_more: data.has_more }
  },
  async unreadCount(signal?: AbortSignal) {
    const { data } = await http.get<{ unread_count: number }>('/notifications/unread-count', { signal })
    return data.unread_count
  },
  /** Reading one notification marks it read. */
  async read(id: string, lang: ContentLocale) {
    const { data } = await http.get<InboxNotification>(`/notifications/${id}`, { params: { lang } })
    return data
  },
  async readAll() {
    await http.post('/notifications/read-all')
  },
}
